import React from "react";
import BondObligeeInformationBase from "../../../../features/bonds/shared/components/BondObligeeInformationBase";
import { getObligeeSurfaceConfig } from "../../../../features/bonds/shared/obligeeInformationConfig";
import {
  GoogleAutoComplete,
  PLACES_TYPES_GEOCODE,
} from "../../../../globals/components/forms/GoogleAutoCompleteField";

const ObligeeRetrieveGoogleAutoComplete = (props) => (
  <GoogleAutoComplete pacZIndex={99999} placesTypes={PLACES_TYPES_GEOCODE} {...props} />
);

export const ObligeeInformationForm = (props) => (
  <BondObligeeInformationBase
    cfg={getObligeeSurfaceConfig("retrieval")}
    GoogleAutoComplete={ObligeeRetrieveGoogleAutoComplete}
    {...props}
  />
);
